<div class="container" *ngIf="formData && pdfSrc">
  <p *ngIf="!isReady">Loading..</p>
  <div class="d-flex justify-content-between mb-3">
    <div></div>
    <button
      class="text-right mt-3"
      mat-raised-button
      color="primary"
      style="color: white"
      (click)="handleFileUpload()"
      [disabled]="isLoading"
      *ngIf="isReady"
    >
      {{ isLoading == true ? "Submitting" : "Submit" }}
    </button>
  </div>
  <ngx-extended-pdf-viewer
    *ngIf="isReady"
    [src]="pdfSrc"
    [(formData)]="formData"
  ></ngx-extended-pdf-viewer>
  <div class="d-flex justify-content-between">
    <div></div>
    <button
      class="text-right mt-3"
      mat-raised-button
      color="primary"
      style="color: white"
      (click)="handleFileUpload()"
      [disabled]="isLoading"
      *ngIf="isReady"
    >
      {{ isLoading == true ? "Submitting" : "Submit" }}
    </button>
  </div>

  <ng-container *ngIf="isLoading">
    <div>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </ng-container>
</div>
